export default [
  'rgba(230,49,91,1)',
  'rgba(121,49,131,1)',
  'rgba(0,157,231,1)',
  'rgba(0,181,156,1)',
  'rgba(255,206,0,1)',
  'rgba(255,74,33,1)',
  'rgba(214,213,214,1)',
  'rgba(255,255,255,1)',
  'rgba(0,0,0,1)',
];



/** WEBPACK FOOTER **
 ** ./src/helpers/textEditor/config/colors.js
 **/